export const linkedinURLRegExp =
  /^https:\/\/(?:[a-z]{2,3}\.)?linkedin\.com\/(school|company|showcase|in)\/([^/?#]+)/;
